var map = {
	"./backhair-1.PNG": 7262,
	"./backhair-2.PNG": 5845,
	"./bang-1.PNG": 7177,
	"./bang-2.PNG": 4562,
	"./base-1.PNG": 272,
	"./eye-1.PNG": 8236,
	"./eye-2.PNG": 583,
	"./mouth-1.PNG": 6326,
	"./mouth-2.PNG": 3517,
	"./norse-1.PNG": 7266,
	"./norse-2.PNG": 4473,
	"./opening1.jpg": 1569,
	"./opening2.jpg": 5782,
	"./opening3.jpg": 4195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6485;